import React, { FC } from "react";
import styles from "../AIButton.module.scss";

interface Props {
  state: string;
  error: string;
  width: number;
}

const AIDialogProcess: FC<Props> = (props) => {
  const { state, error, width } = props;

  return (
    <>
      {state === "thinking" && (
        <div className={styles.dialogBody}>
          <svg
            className={styles.iconLoading}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              d="M21 12a9 9 0 11-6.219-8.56"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          <div className={styles.dialogText}>Thinking...</div>
          <div className={styles.progressBar}>
            <div
              className={styles.progressFill}
              style={{ width: `100%`, transform: `scaleX(0.${width})` }}
            ></div>
          </div>
        </div>
      )}
      {state === "error" && (
        <div className={styles.dialogBody}>
          <svg
            className={styles.iconError}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              strokeWidth="2"
            />
            <line
              x1="15"
              y1="9"
              x2="9"
              y2="15"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="9"
              y1="9"
              x2="15"
              y2="15"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          <div className={styles.dialogText}>Something went wrong, please try again.</div>
          <div className={styles.errorBox}>ERROR: {error}</div>
        </div>
      )}
    </>
  );
};

export default AIDialogProcess;
